module.exports = __webpack_public_path__ + "static/media/ic_reload.219cf943.svg";